/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

import '@jupyterlab/application/style/index.js';
import '@jupyterlab/mainmenu/style/index.js';
import '@jupyterlab/ui-components/style/index.js';

import './base.css';
import './sidepanel.css';
